import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, BoxProps } from '@mui/material';
import { DriverWait } from '../../utils/calculateDriverWaits';

interface TopWaitingDriversProps extends BoxProps {
  drivers: DriverWait[];
}

export const TopWaitingDrivers: React.FC<TopWaitingDriversProps> = ({ drivers, sx }) => {
  const columns: GridColDef[] = [
    { field: 'driver_name', headerName: 'Motorista', flex: 1, headerAlign: 'left', align: 'left' },
    { field: 'license_plate', headerName: 'Placa', flex: 1, headerAlign: 'left', align: 'left' },
    {
      field: 'tempo_espera',
      headerName: 'Tempo de Espera',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        <Box
          sx={{
            bgcolor: 'warning.light',
            color: 'warning.dark',
            px: 2,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 'bold',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: 'deposito_id',
      headerName: 'Depósito',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
  ];


  const rows = drivers.map((driver, index) => ({ id: index, ...driver }));

  return (
    <Box sx={{ height: 400, width: '100%', ...sx }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 5, page: 0 } },
        }}
        pageSizeOptions={[5, 10, 25]}
        disableRowSelectionOnClick
        autoHeight
      />
    </Box>
  );
};
